"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionState = exports.OpenSourceCategory = exports.CallToActionTypes = exports.LaunchStage = void 0;
var LaunchStage;
(function (LaunchStage) {
    LaunchStage["LAUNCH_STAGE_UNSPECIFIED"] = "LAUNCH_STAGE_UNSPECIFIED";
    LaunchStage["EXPERIMENTAL"] = "EXPERIMENTAL";
    LaunchStage["PRIVATE_PREVIEW"] = "PRIVATE_PREVIEW";
    LaunchStage["PUBLIC_PREVIEW"] = "PUBLIC_PREVIEW";
    LaunchStage["GA"] = "GA";
})(LaunchStage || (exports.LaunchStage = LaunchStage = {}));
var CallToActionTypes;
(function (CallToActionTypes) {
    CallToActionTypes["ViewRestApi"] = "viewRestApi";
    CallToActionTypes["OpenNotebook"] = "openNotebook";
    CallToActionTypes["OpenNotebooks"] = "openNotebooks";
    CallToActionTypes["CreateApplication"] = "createApplication";
    CallToActionTypes["OpenFineTuningPipeline"] = "openFineTuningPipeline";
    CallToActionTypes["OpenFineTuningPipelines"] = "openFineTuningPipelines";
    CallToActionTypes["OpenPromptTuningPipeline"] = "openPromptTuningPipeline";
    CallToActionTypes["OpenGenie"] = "openGenie";
    CallToActionTypes["Deploy"] = "deploy";
    CallToActionTypes["MultiDeployVertex"] = "multiDeployVertex";
    CallToActionTypes["DeployGke"] = "deployGke";
    CallToActionTypes["OpenGenerationAiStudio"] = "openGenerationAiStudio";
    CallToActionTypes["RequestAccess"] = "requestAccess";
    CallToActionTypes["OpenEvaluationPipeline"] = "openEvaluationPipeline";
})(CallToActionTypes || (exports.CallToActionTypes = CallToActionTypes = {}));
var OpenSourceCategory;
(function (OpenSourceCategory) {
    OpenSourceCategory["OPEN_SOURCE_CATEGORY_UNSPECIFIED"] = "OPEN_SOURCE_CATEGORY_UNSPECIFIED";
    OpenSourceCategory["PROPRIETARY"] = "PROPRIETARY";
    OpenSourceCategory["GOOGLE_OWNED_OSS_WITH_GOOGLE_CHECKPOINT"] = "GOOGLE_OWNED_OSS_WITH_GOOGLE_CHECKPOINT";
    OpenSourceCategory["THIRD_PARTY_OWNED_OSS_WITH_GOOGLE_CHECKPOINT"] = "THIRD_PARTY_OWNED_OSS_WITH_GOOGLE_CHECKPOINT";
    OpenSourceCategory["GOOGLE_OWNED_OSS"] = "GOOGLE_OWNED_OSS";
    OpenSourceCategory["THIRD_PARTY_OWNED_OSS"] = "THIRD_PARTY_OWNED_OSS";
})(OpenSourceCategory || (exports.OpenSourceCategory = OpenSourceCategory = {}));
var VersionState;
(function (VersionState) {
    VersionState[VersionState["VERSION_STATE_UNSPECIFIED"] = 0] = "VERSION_STATE_UNSPECIFIED";
    VersionState[VersionState["VERSION_STATE_STABLE"] = 1] = "VERSION_STATE_STABLE";
    VersionState[VersionState["VERSION_STATE_UNSTABLE"] = 2] = "VERSION_STATE_UNSTABLE";
})(VersionState || (exports.VersionState = VersionState = {}));
